import React, { useMemo } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns } from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false;

const Table1 = ({ data, maxModuleCount, reactVerbosity }) => {
  // console.log('Table1 RENDERING');
  // data.forEach((s, i) => {
  //   const countStr = `${s.sessionCount}/${s.sessions}`
  //   data[i].sessionCount = countStr;
  // });
  // console.log('====> maxModuleCount:', maxModuleCount)

  // console.log('###################> TABLE1 DATA PRE:', data);
  
  // data.forEach((s, i) => {
  //   const countStr = `${s.sessionCount}/${s.sessionCountOrg}`;
  //   data[i].sessionCount = countStr;
  //   const moduleCountStr = `${s.modules}/${maxModuleCount}`;
  //   data[i].modules = moduleCountStr;
  // });
  reactVerbosity === 2 &&
    console.log('###################> TABLE1 DATA:', data);
  // console.log('###################> TABLE1 DATA AFTER:', data);

  const columns = useMemo(() => [
    {
      accessorKey: 'name', // access nested data with dot notation
      header: 'Name'
    },
    {
      accessorKey: 'region',
      header: 'Region'
    },
    {
      accessorKey: 'modules',
      header: 'Modules'
    },
    {
      accessorKey: 'sessionCount', // normal accessorKey
      header: 'Sessions (Trainee/Org)'
    },
    {
      accessorKey: 'negotiationTime',
      header: 'Negotiation (min)'
    },
    {
      accessorKey: 'negotiations',
      header: 'Negotiations'
    }
  ]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    initialState: {
      density: 'xs',
      expanded: true,
      pagination: { pageIndex: 0, pageSize: 20 }
    },
    mantineTableContainerProps: { 
      sx: { 
        height: '64%',
        maxHeight: 'calc(80vh * 0.8)',
        paddingLeft: '16px',  // Add left padding
        paddingRight: '16px', // Add right padding
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
      } 
    },
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnDragging: false,
    mantineTopToolbarProps: {
      sx: {
        backgroundColor: 'white',
        borderRadius: '8px 8px 0 0',
        paddingTop: '0px',
        marginTop: '8px',
        marginBottom: '0px',
      },
    },
    mantineTableProps: {
      sx: {
        borderRadius: '8px 8px 0 0',
        overflow: 'hidden',
        flex: 1, // Allow table to fill remaining space
      },
    },
    mantineToolbarAlertBannerProps: {
      color: 'blue',
    },
    positionToolbarAlertBanner: 'bottom',
    mantinePaperProps: {
      sx: {
        '& .mantine-ActionIcon-root': {
          backgroundColor: '#e9ecef !important',
          borderRadius: '8px !important',
          margin: '0 4px',
          width: '32px !important',
          height: '32px !important',
          '&:hover': {
            backgroundColor: '#dee2e6 !important',
          },
          '& svg': {
            width: '16px !important',
            height: '16px !important',
          },
        },
        '& .mantine-TableFooter-root': {
          backgroundColor: '#e9ecef !important',
        },
        '& .mantine-TableFooter-root td': {
          fontWeight: 'bold !important',
          color: '#333 !important',
          padding: '12px 16px !important',
        },
        // Style the bottom toolbar (pagination area)
        '& .mantine-Table-root + div': {
          backgroundColor: '#e9ecef !important',
          padding: '8px 16px',
          borderRadius: '0 0 8px 8px', // Add border radius to bottom corners
        },
      },
    },
    mantineTableHeadCellProps: {
      sx: {
        backgroundColor: '#e9ecef',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: '#333',
        padding: '8px 6px',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        padding: '8px 6px', // Adjust padding for body cells
      },
    },
    icons: {
      IconColumns: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="18px"
          height="18px"
        >
          <path d="M0 0h24v24H0z" fill="none"/>
          <circle cx="3.5" cy="7" r="1.5"/>
          <rect x="8" y="6" width="13" height="2"/>
          <circle cx="3.5" cy="12" r="1.5"/>
          <rect x="8" y="11" width="13" height="2"/>
          <circle cx="3.5" cy="17" r="1.5"/>
          <rect x="8" y="16" width="13" height="2"/>
        </svg>
      ),
      IconFilter: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
      ),
      IconSearch: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      )
    },
    mantineBottomToolbarProps: {
      sx: {
        backgroundColor: '#e9ecef !important',
        borderRadius: '0 0 8px 8px', // Add border radius to bottom corners
        margin: '8px 16px', // Match the side padding
      },
    },
  });

  return <MantineReactTable table={table} />;
};

export default React.memo(Table1);
